import { getReceptorTemplate } from 'src/xgenerated'

// The text of a "View in ..." source link, as ViewInSourceButton shows it: the short
// name when one is given, else the receptor's name, else "Source". Index page searches
// use it so a row is found by the source it names.
export const getViewInSourceLabel = (
  receptorModelId: string,
  shortName?: string,
): string => {
  if (shortName) {
    return `View in ${shortName}`
  }
  try {
    return `View in ${getReceptorTemplate(receptorModelId)?.name || 'Source'}`
  } catch {
    return 'View in Source'
  }
}
